import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaCode,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <>
      <footer id="footer" className="custom-footer">
        <Container fluid className="px-md-5 px-3">
          <Row className="g-4">
            {/* Column 1: Brand/About */}
            <Col lg={3} md={6}>
              <Link
                to="/"
                className="custom-footer-logo d-flex align-items-center mb-3"
              >
                <img src={config?.logo} alt="logo" className="logo" />
              </Link>
              <p className="footer-text">Bespoke Clothing – shine with grace</p>
            </Col>

            {/* Column 3: Customer Service */}
            <Col lg={2} md={6} xs={6}>
              <h5 className="footer-heading">Useful Links</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>

                <li>
                  <Link to="/return-and-refund-policy">
                    Return and Refund Policy
                  </Link>
                </li>
              </ul>
            </Col>
            {/* Column 2: Quick Links */}
            <Col lg={2} md={6} xs={6}>
              <h5 className="footer-heading">Information</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/shop">Shop </Link>
                </li>
                <li>
                  <Link to="/blog">Blogs</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </Col>
            <Col lg={2} md={6} xs={6}>
              <h5 className="footer-heading">Categories</h5>

              <ul className="footer-links">
                {categories?.slice(0, 5).map((cat) => (
                  <li key={cat._id}>
                    <Link to={`/categories/${cat.slugPath}`}>{cat.name}</Link>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Column 4: Newsletter */}
            <Col lg={3} md={6}>
              <h5 className="footer-heading">Get In Touch</h5>
              <ul className="tf-social-icon d-flex gap-2 list-unstyled align-items-center m-0 p-0">
                {config?.socialMedia?.facebook && (
                  <li>
                    <a
                      href={config.socialMedia.facebook}
                      target="_blank"
                      className="social-icon-link"
                    >
                      <FaFacebook size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.instagram && (
                  <li>
                    <a
                      href={config.socialMedia.instagram}
                      target="_blank"
                      className="social-icon-link"
                    >
                      <FaInstagram size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.twitter && (
                  <li>
                    <a
                      href={config.socialMedia.twitter}
                      target="_blank"
                      className="social-icon-link"
                    >
                      <FaTwitter size={16} />
                    </a>
                  </li>
                )}
                {config?.socialMedia?.youtube && (
                  <li>
                    <a
                      href={config.socialMedia.youtube}
                      target="_blank"
                      className="social-icon-link"
                    >
                      <FaYoutube size={16} />
                    </a>
                  </li>
                )}
              </ul>
            </Col>
          </Row>

          {/* Bottom Bar: Copyright & Social */}
          <div className="footer-bottom mt-5 pt-4 border-top">
            <Row className="align-items-center">
              <Col md={6} className="text-start">
                <p className="mb-0 footer-text">
                  All Rights Reserved © 2026 Bespoke Clothing
                </p>
              </Col>
              <Col md={6} className="text-end">
                <a
                  href="https://axesell.com"
                  className="floating-designer-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="floating-content">
                    <img
                      src="/images/axesell_logo.png"
                      className="floating-icon"
                      alt="Axesell"
                    />
                  </div>
                </a>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
